export enum AIAgentType {
  RoleDetailsAgentType = 'RoleDetailsAgentType',
  SkillDetailsAgentType = 'SkillDetailsAgentType',
  RegenerateRoleAgentType = 'RegenerateRoleAgentType',
  RegenerateSkillsAgentType = 'RegenerateSkillsAgentType',
  SuggestProficiencyAgentType = 'SuggestProficiencyAgentType',
}
